<template>
  <vx-card no-shadow>

    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onClickSubmit)" autocomplete="off">

        <!--        <vs-divider class="mt-8 mb-12" color="primary" position="center">Genaral Informations</vs-divider>-->


        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/3 md:mb-0">
            <ValidationProvider vid="is_additive_preservative" name="is_additive_preservative" rules="" v-slot="{ errors }">
              <small class="label">Is additives and/or preservatives present?</small>
              <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="form.is_additive_preservative" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
        </div>

        <div v-if="form.is_additive_preservative" v-for="(identity, index) in form.additive_preservative_identity" :key="index" class="mt-8">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/3 w-full md:mb-0">
              <ValidationProvider :vid="index+'identity'" :name="index+'identity'" rules="required" v-slot="{ errors }">
                <small class="label">Additive/Preservative identity</small>
                <vs-input :disabled="__isDisabledRawMaterial(status)" v-model="identity.identity" type="text" name="identity" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/3 w-full md:mb-0">
              <ValidationProvider  :vid="index+'number'" :name="index+'number'" rules="required" v-slot="{ errors }">
                <small class="label">E number</small>
                <vs-input :disabled="__isDisabledRawMaterial(status)"  v-model="identity.number" type="text" name="number" class="w-full" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/3 w-full md:mb-0">
              <ValidationProvider  :vid="index+'amount_present'" :name="index+'amount_present'" rules="required" v-slot="{ errors }">
                <small class="label">Amount present</small>
                <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" name="amount_present" class="w-full" v-model="identity.amount_present" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/3 md:mb-0">
              <ValidationProvider :vid="index+'is_finished'" :name="index+'is_finished'" rules="" v-slot="{ errors }">
                <small class="label">Added to finished product?</small>
                <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="identity.is_finished" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                  <span slot="on">Yes</span>
                  <span slot="off">No</span>
                </vs-switch>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-2/3 w-full md:mb-0">
              <ValidationProvider v-if="identity.is_finished" :vid="index+'is_finished_comment'" :name="index+'is_finished_comment'" rules="required" v-slot="{ errors }">
                <small class="label">If Yes, Give details</small>
                <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" v-model="identity.is_finished_comment" name="is_finished_comment" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/3 md:mb-0">
              <ValidationProvider :vid="index+'is_carryover'" :name="index+'is_carryover'" rules="" v-slot="{ errors }">
                <small class="label">Present as carryover?</small>
                <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="identity.is_carryover" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                  <span slot="on">Yes</span>
                  <span slot="off">No</span>
                </vs-switch>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-2/3 w-full md:mb-0">
              <ValidationProvider v-if="identity.is_carryover" :vid="index+'is_carryover_comment'" :name="index+'is_carryover_comment'" rules="required" v-slot="{ errors }">
                <small class="label">If Yes, Give details</small>
                <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" v-model="identity.is_carryover_comment" name="is_carryover_comment" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <vs-button :disabled="form.is_additive_preservative && form.additive_preservative_identity.length === 1" class="float-right mt-0 mb-8" @click="deleteIdentity(index)" size="small" color="danger" type="filled" icon-pack="feather" icon="icon-x">delete</vs-button>
            </div>
          </div>
        </div>
        <vs-button v-if="form.is_additive_preservative" @click="addIdentity" size="small" color="success" type="filled" icon-pack="feather" icon="icon-plus">Add additive/preservative identity</vs-button>

        <div class="vx-row mb-3 mt-8">
          <div class="vx-col md:w-1/3 md:mb-0">
            <ValidationProvider vid="is_additives_compliant" name="is_additives_compliant" rules="" v-slot="{ errors }">
              <small class="label">Are all additives compliant with Regulation (EC) No 1333/2008 on food additives?</small>
              <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="form.is_additives_compliant" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-2/3 w-full md:mb-0">
            <ValidationProvider v-if="form.is_additives_compliant" vid="is_additives_compliant_comment" name="is_additives_compliant_comment" rules="required" v-slot="{ errors }">
              <small class="label">If Yes, Give details</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" v-model="form.is_additives_compliant_comment" name="is_additives_compliant_comment" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
            </ValidationProvider>
          </div>
        </div>

        <div class="flex flex-wrap items-center justify-end">
          <vs-button v-if="status.is_raw_material_additives_preservative_complete"  button="submit" class="ml-auto mt-2" :disabled="__isDisabledRawMaterial(status)">Save Changes</vs-button>
          <vs-button v-else button="submit" class="mt-2 ml-4" :disabled="__isDisabledRawMaterial(status)">Save Changes</vs-button>
        </div>
      </form>
    </ValidationObserver>
  </vx-card>

</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  const SupplierRawMaterialRepository = RepositoryFactory.get('supplierRawMaterial')

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  export default {
    name: "SupplierManufacturingHome",
    data() {
      return {
        form: {
          additive_preservative_identity: [
            {identity: '', number: '', amount_present: '', is_finished:  false, is_finished_comment: '', is_carryover: false, is_carryover_comment: ''}
          ],
          is_additive_preservative: false,
          is_additives_compliant: false
        },
        id: null,
        status: {},
      }
    },
    mixins: [SuccessMessage, ErrorMessages],
    methods: {
      onClickNext() {
        this.$emit('notify', 1)
      },
      onClickSubmit() {
        this.status.is_raw_material_additives_preservative_complete ? this.onClickUpdate() : this.onClickCreate()
      },

      async onClickUpdate() {
        this.$vs.loading()
        try {
          if (!this.form.is_additive_preservative) {
            this.form.additive_preservative_identity = []
          }
          const data= (await SupplierRawMaterialRepository.UpdateRawMaterialAdditivePreservative(this.id, this.form))
          this.showSuccessMessage('Raw Material Additive Preservative Details Updated!')
          this.onClickNext()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async onClickCreate() {
        this.$vs.loading()
        try {
          if (!this.form.is_additive_preservative) {
            this.form.additive_preservative_identity = []
          }
          const data= (await SupplierRawMaterialRepository.CreateRawMaterialAdditivePreservative(this.form))
          this.showSuccessMessage('Raw Material Additive Preservative Details Created!')
          this.onClickNext()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },

      async loadData() {
        this.$vs.loading()
        const {data} = (await SupplierRawMaterialRepository.getRawMaterialAdditivePreservative(this.id)).data
        this.form =data
        if (this.form.additive_preservative_identity.length === 0) {
          this.addIdentity()
        }
        this.$vs.loading.close()
      },
      async loadStatus() {
        this.$vs.loading()
        const {data} = (await SupplierRawMaterialRepository.getRawMaterialStatus(this.id)).data
        this.status =data
        this.$vs.loading.close()
      },
      addOther() {
        this.other.push({
          is_other_name: '',
          is_other_temp: ''
        })
      },
      addIdentity() {
        this.form.additive_preservative_identity.push(
          {identity: '', number: '', amount_present: '', is_finished:  false, is_finished_comment: '', is_carryover: false, is_carryover_comment: ''}
        )
      },
      deleteIdentity(index) {
        this.form.additive_preservative_identity.splice(index, 1)
      }
    },
    async mounted() {
      this.id = this.$route.params.id
      this.form.supplier_raw_material_id =  this.id
      await this.loadStatus()
      if (this.status.is_raw_material_additives_preservative_complete) {
        await this.loadData()
      }
    }
  }
</script>

<style scoped>

</style>
